import React, { useEffect, useState } from "react";
import "./furniture.css";
import furnitureImage from "../images/furniture.png"; // Replace with your actual image path

const stats = [
  {
    number: 1500000,
    suffix: "+",
    label: "SQ FT VERTICAL INTEGRATION",
  },
  {
    number: 20000,
    suffix: "+",
    label: "FURNITURE UNITS / MONTH",
  },
  {
    number: 500,
    suffix: "+",
    label: "DEDICATED WORK FORCE",
  },
  {
    number: 22,
    suffix: "+",
    label: "YEARS OF EXPERIENCE",
  },
  {
    number: 5,
    suffix: "",
    label: "CONTINENTS COVERED",
  },
  {
    number: 1,
    suffix: "",
    label: "GOAL",
  },
];

function CountUp({ end, suffix }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;

    const duration = 2500;
    const increment = end / 100;

    const timer = setInterval(() => {
      start += increment;

      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, duration / 100);

    return () => clearInterval(timer);
  }, [end]);

  return (
    <>
      {count.toLocaleString()}
      {suffix}
    </>
  );
}

export default function LuxuryFurnitureSection() {
  return (
    <section className="furniture-section">
      <div className="furniture-container">

        {/* Background Glow */}
        <div className="bg-blur one"></div>
        <div className="bg-blur two"></div>

        <div className="furniture-grid">

          {/* Left Image Section */}
          <div className="image-side">

            <img
              src={furnitureImage}
              alt="Luxury Furniture"
            />

            <div className="image-overlay"></div>

            {/* Premium Badge */}
            <div className="premium-badge">
              ★ Premium Export Quality
            </div>

            {/* Floating Glass Card */}
            <div className="floating-card">

              <p className="small-title">
                Premium Interior
              </p>

              <h2 className="main-heading">
                Conscious Living
                <br />
                Crafted Beautifully
              </h2>

              <p className="card-description">
                Luxury furniture blending timeless elegance
                with modern craftsmanship for global interiors.
              </p>

            </div>
          </div>

          {/* Right Stats Section */}
          <div className="stats-side">

            <div className="stats-content">

              <div className="section-title">

                <p>Company Overview</p>

                <h1>
                  Built For Elegant
                  <br />
                  Modern Living
                </h1>

              </div>

              <div className="stats-grid">

                {stats.map((item, index) => (
                  <div
                    key={index}
                    className="stat-item"
                  >

                    <h2 className="stat-number">
                      <CountUp
                        end={item.number}
                        suffix={item.suffix}
                      />
                    </h2>

                    <p className="stat-label">
                      {item.label}
                    </p>

                  </div>
                ))}

              </div>

              <div className="bottom-text">
                consciously engineered
              </div>

            </div>

          </div>

        </div>
      </div>
    </section>
  );
}